// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__2CnKD","log":"ModalInventoryLogs_log__dCUz7","date":"ModalInventoryLogs_date__3H6uu","userName":"ModalInventoryLogs_userName__1Szsf"};